require.context('./assets/images', true)
import './assets/styles'
import Swiper from 'swiper'

var currentCarIndex = 0;

var prevButton = document.getElementById('sizes__table-prev-button')
var nextButton = document.getElementById('sizes__table-next-button')
var sizesSlider = document.getElementById('sizes__table-columns')

prevButton.addEventListener('click', event => {
  if (currentCarIndex === 3) nextButton.style = 'visibility: visible;'
  if (currentCarIndex > 0) currentCarIndex -= 1
  sizesSlider.style = `transform: translateY(-${468*currentCarIndex}px)`
  if (currentCarIndex === 0) prevButton.style = 'visibility: hidden;'
})

nextButton.addEventListener('click', event => {
  if (currentCarIndex === 0) prevButton.style = 'visibility: visible;'
  if (currentCarIndex < 3) currentCarIndex += 1
  sizesSlider.style = `transform: translateY(-${468*currentCarIndex}px)`
  if (currentCarIndex === 3) nextButton.style = 'visibility: hidden;'
})

new Swiper('.feedback__carts', {
  wrapperClass: 'feedback__carts-wrapper',
  slideClass: 'feedback__cart',
  direction: 'horizontal',
  slidesPerView: 4,
  spaceBetween: 30,
  breakpoints: {
    1199: { slidesPerView: 3 },
    1023: { slidesPerView: 2 },
    767: { slidesPerView: 1 }
  },
  pagination: {
    el: '.feedback__carts-pagination',
    type: 'bullets'
  }
})
